/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-statements */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
// import SideFilterSearch from "../../side-filter-search";
import PopularMakePills from "../../popular-make-pills/component";
import ModelFilterRevamp from "./model-filter-revamp";
import PopularBrandPopupContent from "../popular-brand-popup-content/component";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import getUpdatedAppliedFilters from "../../../../utils/filters-v2/get-updated-applied-filters";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { yieldToMain } from "../../../../utils/helpers/yield-to-main";
import { AU_FILTER_EVENT, AU_FILTER_EVENTS_KEYS } from "../../../../tracking/au.mobile-filter-events";

const initialState = {
    isVisible: false,
    visibleMake: ""
};

const arrayToObject = (allFilters) => {
    const makes = (allFilters || []).make || {};
    return (makes.options || []).reduce((obj, item) => Object.assign(obj, { [item.key]: { ...item } }), {});
};

// eslint-disable-next-line max-statements
const MakeModelFilter = ({
    allMakes,
    popularMakes,
    selectedFilters,
    allFilters,
    onOptionSelection,
    config,
    removedMakeFilter,
    clearSelectedFilterConnect,
    updateAllSubFilterOptionsConnect,
    updateFilterOptionDataConnect,
    reloadCarListConnect,
    getListingUrl,
    ...rest
}) => {
    const sanitizeMakeToObject = arrayToObject(allFilters);

    const [showAllBrands, setShowAllBrands] = useState();
    const [selectedMake, setSelectedMake] = useState("A");
    const [popupData, setPopupData] = useState(initialState);
    const [isMakeSelected, setIsMakeSelected] = useState({});

    const modelWrapper = useRef(null);
    const allMakesModelWrapper = useRef(null);
    const modelPopWrapper = useRef(null);

    const alphaBetMakes = (allMakes || {}).suggestions;
    const popularBrands = (popularMakes || {}).suggestions;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClickOutside = (event) => {
        if (modelPopWrapper.current && modelPopWrapper.current.contains(event.target)) {
            return null;
        } else if (
            showAllBrands &&
            modelWrapper.current &&
            !modelWrapper.current.contains(event.target) &&
            allMakesModelWrapper.current &&
            !allMakesModelWrapper.current.contains(event.target)
        ) {
            setPopupData({ ...popupData, isVisible: false });
        } else if (!showAllBrands && modelWrapper.current && !modelWrapper.current.contains(event.target)) {
            setPopupData({ ...popupData, isVisible: false });
        }
        return null;
    };

    useEffect(() => {
        const currentRemovedFilter = removedMakeFilter ? removedMakeFilter.toUpperCase() : "";
        if (selectedFilters.length === 0) {
            setIsMakeSelected({});
        } else if (isMakeSelected.hasOwnProperty(currentRemovedFilter)) {
            setIsMakeSelected({
                ...isMakeSelected,
                [currentRemovedFilter]: false
            });
            clearSelectedFilterConnect("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFilters.length]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, [showAllBrands, popupData]);

    const handleAllMakes = () => {
        setShowAllBrands(!showAllBrands);
    };

    const handleSelectedMake = (key) => {
        if (alphaBetMakes[key].length === 0) {
            return;
        }
        setSelectedMake(key);
    };

    const handleClose = async () => {
        await yieldToMain();
        setPopupData(initialState);
    };

    // const onBlurMakeSection = () => {
    //     setPopupData({...popupData, isVisible: false});

    // };

    // eslint-disable-next-line max-params
    const handleSelect = (filterKey, optionKey, subOptionKey, isSelected, displayText, isMakeClicked) => {
        setIsMakeSelected({
            ...isMakeSelected,
            [optionKey]: isMakeClicked
        });

        onOptionSelection({ filterKey, optionKey, isSelected, displayText, ...(subOptionKey && { subOptionKey }) });
        // onOptionSelection()
    };

    const checkOptionSelected = (item) => {
        const obj = { isAllOptionSelected: false, isAnyOptionSelected: false };
        const allOptions = allFilters.make && allFilters.make.options;
        const model = allOptions.find((it) => it.key.toLowerCase() === item.toLowerCase());
        const modelOptions = (model.subFilter && model.subFilter.options) || [];
        const filterMatched = selectedFilters.length
            ? selectedFilters.filter((it) => (it.optionKey || "").toLowerCase() === item.toLowerCase())
            : [];
        const isModelAvailable = selectedFilters.find(
            (it) => (it.optionKey || "").toLowerCase() === item.toLowerCase() && it.subOptionKey
        );
        if (selectedFilters.length === 0) {
            obj.isAllOptionSelected = false;
            obj.isAnyOptionSelected = false;
        } else if (isModelAvailable && modelOptions.length !== filterMatched.length) {
            obj.isAnyOptionSelected = true;
        } else if (modelOptions.length === filterMatched.length || (!isModelAvailable && filterMatched.length)) {
            obj.isAllOptionSelected = true;
        }
        return obj;
    };

    const getSelectedMakeChar = () => {
        let obj = {};
        selectedFilters.forEach((item) => {
            if (item.filterKey === "make") {
                const char = item.optionKey ? item.optionKey.charAt(0) : "";
                obj = {
                    ...obj,
                    [char]: true
                };
            }
        });
        return obj;
    };

    // eslint-disable-next-line max-params
    const onChangeSubFilterOption = (filterKey, filterOptionKey, subFilterOptionKey, isSelectedValue, displayText) => {
        const data = {
            filterKey,
            optionKey: filterOptionKey,
            subOptionKey: subFilterOptionKey,
            isSelected: isSelectedValue,
            displayText,
            isAllModelVariant: true
        };
        updateFilterOptionDataConnect(data);
        if (isSelectedValue) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_MODEL_SELECTED_ON, {
                eventLabel: `${subFilterOptionKey}`
            });
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_DESELECTED_CONTAINER, {
                eventLabel: `${subFilterOptionKey}`
            });
        }
        const updateFiter = getUpdatedAppliedFilters(data, selectedFilters);
        getListingUrl(updateFiter);
        reloadCarListConnect(true);
    };

    const onChangeAllSubOptions = async (optionKey, isSelected, isPopularMakeSelected) => {
        const data = {
            filterKey: "make",
            optionKey,
            isSelected,
            isAllModelVariant: true,
            displayText: optionKey
        };

        // Determine tracking events early
        const gaEventPillSelect = isPopularMakeSelected
            ? AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_POPULAR_MAKE_SELECTED
            : AU_FILTER_EVENTS_KEYS.FILTER_REVAMP_FILTER_MAKE_SELECTED;

        const gaEventPillDeselect = isPopularMakeSelected
            ? AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_DESELECTED_PILL
            : AU_DESKTOP_EVENTS.FILTER_REVAMP_FILTER_DESELECTED_CONTAINER;

        try {
            // Group all state updates
            const updateFiter = getUpdatedAppliedFilters(data, selectedFilters);

            // Run all async operations concurrently
            await Promise.all([
                updateAllSubFilterOptionsConnect(data),
                getListingUrl(updateFiter),
                yieldToMain()
            ]);

            // Update UI states after main operations
            setPopupData({
                ...popupData,
                isVisible: popupData.visibleMake === optionKey && popupData.isVisible ? false : true,
                visibleMake: optionKey
            });
            reloadCarListConnect(true);
            // Track event based on selection state
            trackDesktopCustomEventsAU(
                isSelected ? gaEventPillSelect : gaEventPillDeselect,
                {
                    ...AU_FILTER_EVENT[gaEventPillSelect],
                    eventLabel: optionKey }
            );
        // eslint-disable-next-line no-empty
        } catch (error) {

        }
    };

    const selectedCharacterMap = getSelectedMakeChar();

    return (
        <div styleName={"styles.makeModelOuter"}>
            <div styleName={"styles.searchWrap"}>
                {/* <SideFilterSearch /> */}
                <ModelFilterRevamp
                    {...rest}
                    selectedFilters={selectedFilters}
                    allFilters={allFilters}
                    onOptionSelection={onOptionSelection}
                    getListingUrl={getListingUrl}
                />
            </div>
            <p styleName={"styles.popularMakeHeading"}>Popular Makes</p>
            <div styleName={"styles.popularMakeWrapper"} ref={modelWrapper}>
                {popularBrands && popularBrands.map(item => {
                    const {isAllOptionSelected, isAnyOptionSelected} = checkOptionSelected(item.make);
                    return  (
                        <PopularMakePills
                            brandImage={config.imageHost + item.makeImage}
                            makeCount={item.makeCount}
                            isPartialSelected={isAnyOptionSelected}
                            isAllFilterSelected={isAllOptionSelected}
                            onClick={onChangeAllSubOptions.bind(null, item.make, !isAllOptionSelected, true)}
                            config={config}
                            // handleMouseLeave={handleMouseLeave}
                        />
                    );
                }
                )}
            </div>

            {showAllBrands && (
                <React.Fragment>
                    <p styleName={"styles.allBrandHeading"}>All Makes</p>
                    <div styleName={"styles.albhabetWrap"}>
                        {alphaBetMakes &&
                            Object.keys(alphaBetMakes).map((item) => (
                                // eslint-disable-next-line no-nested-ternary
                                <p
                                    styleName={
                                        selectedCharacterMap[item]
                                            ? "styles.activeAlphabet"
                                            : alphaBetMakes[item].length === 0
                                                ? "styles.dull"
                                                : ""
                                    }
                                    onClick={handleSelectedMake.bind(null, item)}
                                >
                                    {item}
                                </p>
                            ))}
                    </div>
                    <div styleName={"styles.popularMakeWrapper"} ref={allMakesModelWrapper}>
                        {selectedMake &&
                            alphaBetMakes[selectedMake].map((item) => {
                                const { isAllOptionSelected, isAnyOptionSelected } = checkOptionSelected(item.make);
                                return (
                                    <PopularMakePills
                                        brandImage={config.imageHost + item.makeImage}
                                        makeCount={item.makeCount}
                                        isPartialSelected={isAnyOptionSelected}
                                        isAllFilterSelected={isAllOptionSelected}
                                        onClick={onChangeAllSubOptions.bind(
                                            null,
                                            item.make,
                                            !isAllOptionSelected,
                                            false
                                        )}
                                        config={config}
                                    />
                                );
                            })}
                    </div>
                </React.Fragment>
            )}
            <p styleName={"styles.showLess"} onClick={handleAllMakes}>
                {showAllBrands ? "Show less" : "See all Makes"}{" "}
            </p>
            {popupData.isVisible && (
                <div styleName={"styles.popupWrapper"} tabindex="-1" ref={modelPopWrapper}>
                    <PopularBrandPopupContent
                        selectedMake={sanitizeMakeToObject[popupData.visibleMake]}
                        handleSelect={handleSelect}
                        appliedFilters={selectedFilters}
                        config={config}
                        handleClose={handleClose}
                        onChangeAllSubOptions={onChangeAllSubOptions}
                        onChangeSubFilterOption={onChangeSubFilterOption}
                        {...checkOptionSelected(popupData.visibleMake)}
                    />
                </div>
            )}
        </div>
    );
};

MakeModelFilter.propTypes = {
    allMakes: PropTypes.object,
    popularMakes: PropTypes.object,
    selectedFilters: PropTypes.array,
    allFilters: PropTypes.object,
    onOptionSelection: PropTypes.func,
    config: PropTypes.object,
    removedMakeFilter: PropTypes.string,
    clearSelectedFilterConnect: PropTypes.func,
    updateAllSubFilterOptionsConnect: PropTypes.func,
    updateFilterOptionDataConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    getListingUrl: PropTypes.func
};

export default React.memo(MakeModelFilter);
